var map = {
	"./decidim/gamification/badges/decidim_gamification_badges_accepted_proposals.svg": 93111,
	"./decidim/gamification/badges/decidim_gamification_badges_proposal_votes.svg": 21260,
	"./decidim/gamification/badges/decidim_gamification_badges_proposals.svg": 72969,
	"./decidim/proposals/decidim_proposals.svg": 24033,
	"./decidim/proposals/proposal-placeholder-card-g.svg": 51061
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12176;